import React, { useEffect, useRef, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { handleAddNewVendorSubmit } from "./RecAgencyFunction";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

function AddNewRecAgency({ onToggle, recAgencyData, setAgencyData }) {
  const dispatch = useDispatch();
  const [vendorsList, setVendorsList] = useState(recAgencyData.vendor);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    if (selectedCountry != null) {
      const filteredVendors = recAgencyData.vendor.filter(
        (vendor) => vendor.nationality_id == selectedCountry
      );
      setVendorsList(filteredVendors); // Uncomment this line if you want to set the filtered vendors in your state.
    } else {
      setVendorsList(recAgencyData.vendor);
    }
  }, [selectedCountry]);

  const { projectId } = useParams();

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center flex`}
    >
      <div className="max-w-xl w-full max-h-fit min-h-[15rem] rounded-md bg-white/95 flex flex-col py-4 px-8 relative">
        <div className="flex justify-between items-center w-full mt-1 mb-3">
          <h1 className="text-xl font-semibold">Add Recruitment Agency</h1>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => onToggle()}
          >
            <IoMdClose />
          </h1>
        </div>
        <form
          onSubmit={(e) =>
            handleAddNewVendorSubmit(
              e,
              selectedVendor,
              projectId,
              setAgencyData,
              recAgencyData,
              setSubmitLoading,
              dispatch,
              onToggle
            )
          }
          className="w-full flex flex-col my-4 gap-3"
        >
          <>
            <div className="flex flex-col gap-1">
              <label className="text-sm">Select Country</label>
              <select
                className="select select-sm select-bordered"
                onChange={(e) => setSelectedCountry(e.target.value)}
              >
                <option value="" selected hidden>
                  Select Country
                </option>
                {recAgencyData.nationality.map((nation) => (
                  <option key={nation.id} value={nation.id}>
                    {nation.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm">Select Recruitment Agency</label>
              <select
                required
                className="select select-sm select-bordered"
                onChange={(e) => setSelectedVendor(e.target.value)}
              >
                {vendorsList.length <= 0 ? (
                  <option value="" selected hidden>
                    No Recruitment Agency Available
                  </option>
                ) : (
                  <option value="" selected hidden>
                    Select Recruitment Agency
                  </option>
                )}
                {vendorsList.length > 0 &&
                  vendorsList.map((vendor) => (
                    <option key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="flex gap-3 mx-auto my-3 w-full px-5">
              <button
                className="p-2 px-4 rounded-md ring-1 ring-slate-300 max-w-xs w-full"
                onClick={() => onToggle()}
                type="button"
              >
                Cancel
              </button>
              <button
                className={`p-2 px-4 rounded-md ring-1 ring-red bg-red text-white max-w-xs w-full flex items-center justify-center gap-2 ${
                  !selectedVendor && "bg-red/80"
                }`}
                type="submit"
                disabled={!selectedVendor ? true : false}
              >
                {submitLoading ? (
                  <CgSpinner className="animate-spin mx-auto" />
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </>
        </form>
      </div>
    </div>
  );
}

export default AddNewRecAgency;
